import { NativeModules } from 'react-native';
import logger from './Utils/Logger';

const { BluestackManager } = NativeModules;

if (!BluestackManager) {
    throw new Error('BluestackManager native module is not available');
}

export const BluestackSDK = {
    initialize(appId: string, enableDebug: boolean = false): Promise<number> {
        if (enableDebug) {
            logger.setDebug(enableDebug);
        }

        logger.log(`Initializing Bluestack SDK with appId: ${appId}`);
        return BluestackManager.initializeSDK(appId, enableDebug);
    },

    isInitialized(): boolean {
        logger.log('Checking Bluestack SDK initialization status');
        return BluestackManager.isSdkInitialized();
    },
};
